import {Injectable} from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import {Router, ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import {HttpRequestService} from '../_common/http-request.service';
import {AppConfigs} from "../app.config";
import {JwtHelper} from "angular2-jwt";

@Injectable()
export class AuthenticationService {

    private jwtHelper: JwtHelper = new JwtHelper();

    constructor(private http: HttpRequestService, private router: Router) {
    }

    login(email: string, password: string) {
        return this.http.post('signin', {email: email, password: password})
            .map((response: Response) => {
                let user = response.json();
                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('userToken', user.token);
                }

                if (user.hasOwnProperty('result')) {
                    if (user.result.hasOwnProperty('userCurrent')) {
                        if (user.result.userCurrent.hasOwnProperty('imgAvatar') && user.result.userCurrent.imgAvatar == null) {
                            user.result.userCurrent['imgAvatar'] = AppConfigs.DEFAULT_IMG_AVATAR;
                        }
                        localStorage.setItem('userCurrent', JSON.stringify(user.result.userCurrent));
                    }
                }
            });
    }

    getCurrentUser() {
        let token = this.getToken();
        let currentUser = null;
        if (token) {
            return this.http.get('currentuser')
                .map(res => {
                    return res.json();
                });
        }

        return null;
    }

    getToken() {
        return localStorage.getItem('userToken');
    }

    logout() {
       this.http.logout();
    }

    getFieldsLocalStorage(nameLocal: any) {
        return localStorage.getItem(nameLocal) ? localStorage.getItem(nameLocal) : null;
    }

    asyncUserCurrent(object) {
        let userCurrent = this.getFieldsLocalStorage('userCurrent');
        if (userCurrent != null) {
            try {
                let updateUserCurrentJson = JSON.parse(userCurrent);

                for (var key in object) {
                    if (key && (updateUserCurrentJson.hasOwnProperty(key))) {
                        updateUserCurrentJson[key] = object[key];
                        localStorage.setItem('userCurrent', JSON.stringify(updateUserCurrentJson));
                    }
                };
            } catch (e) {
            }
        }

        return userCurrent;
    }

    getFieldUserCurrent(name: any = null) {
        let userCurrent = this.getFieldsLocalStorage('userCurrent');
        let fieldValue = null;
        if (userCurrent != null) {
            try {
                let userCurrentJson = JSON.parse(userCurrent);
                if (name && (userCurrentJson.hasOwnProperty(name))) {
                    if (name == 'imgAvatar') {
                        fieldValue = userCurrentJson.imgAvatar ? userCurrentJson.imgAvatar : AppConfigs.DEFAULT_IMG_AVATAR;
                    } else {
                        fieldValue = userCurrentJson[name];
                    }
                }
            } catch (e) {
            }
        }

        return name ? fieldValue : userCurrent;
    }

    checkRoleUser() {
        return this.jwtHelper.decodeToken(this.getToken());
    }
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/authentication.service.ts